import { useEffect } from "react";
import { ToDesktopAppMenuEventNames } from "@desktop/ToDesktopConstants";
import { registerAppMenuEventListener } from "@desktop/ToDestkopEventListeners";
import { useAppModeContext } from "../../app/LifeAtApp/AppModeContext";

export default function AppMenuShortcutListeners() {
    const { setAppMode } = useAppModeContext();

    useEffect(() => {
        const focusModeShortcutListener = registerAppMenuEventListener(ToDesktopAppMenuEventNames.OpenFocusMode, () =>
            setAppMode("focus"),
        );
        const plannerShortcutListener = registerAppMenuEventListener(ToDesktopAppMenuEventNames.OpenPlanner, () =>
            setAppMode("planner"),
        );

        return () => {
            focusModeShortcutListener.then((onfullfilled: () => void) => onfullfilled?.());
            plannerShortcutListener.then((onfullfilled: () => void) => onfullfilled?.());
        };
    }, []);

    return null;
}
